import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { IconContainer, IconWrapper } from './icon.styles';
/**
 * A set of React components that displays one of our many UI icons available.
 * Each component takes a number of props for changing the icon colour, background colour
 * and size. The colours are dynamic and can use any colour token in the Design
 * Tokens.
 *
 * You can't use Icon component directly, instead you should import a specific named icon, like:
 * `import { ChevronUp } from '@awaze/design-system.components.icon'`
 *
 * The list of generated icons is kept in
 * `src/components/icon/react-icons/index.ts`
 *
 * ###__⚠️ NOTE ⚠️__
 *
 * There is a manual process to handle updating the icons available. We manually
 * export the icons available on the
 * [Figma documentation page](https://www.figma.com/file/YchGBDEfQNfQYse4eutSLi/AGE-Design-system?node-id=4923%3A53719)
 * and drop the outputted SVG files into `src/components/icon/icons`. We then run
 * `npm run generate:react-icons` at the root of the project and this uses SVGR
 * to convert all the SVGs in that folder into React components and place them
 * in the `react-icons` folder beside it.
 *
 *
 * Chromatic is very important for this component as it will highlight any icons
 * that have changed, been removed, added etc. Pay close attention to this and
 * your Git diffs on PRs to spot breaking changes.
 */
export const Icon = memo(({ backgroundColour = 'transparent', iconColour = 'ColorGrey800', ChosenIcon, size = 'large', ...rest }) => {
    return (_jsx(IconContainer, { backgroundColour: backgroundColour, iconColour: iconColour, size: size, ...rest, children: _jsx(IconWrapper, { children: _jsx(ChosenIcon, { preserveAspectRatio: "xMidYMid meet", viewBox: "0 0 24 24" }) }) }));
});
//# sourceMappingURL=icon.js.map